import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { LockChanges } from '@ngrx/store-devtools/src/actions';
declare var bootstrap: any;
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { audit } from 'rxjs';
import { Page } from 'src/app/classes/page';
import { AllotService } from 'src/app/services/Allot.service';
import { AuditService } from 'src/app/services/audit.service';
import { AuditStatusService } from 'src/app/services/Auditstatus.service';
import { ConfigService } from 'src/app/services/auth/config.service';
import { FinalChecklistService } from 'src/app/services/finalchecklist.service';
import { SweetAlertService } from 'src/app/toast/sweet-alert.service';
import { ToastService } from 'src/app/toast/toast.service';
@Component({
  selector: 'app-final-checklist',
  templateUrl: './final-checklist.component.html',
  styleUrls: ['./final-checklist.component.scss'],
})
export class FinalChecklistComponent implements OnInit {
  @ViewChild('empForm') empForm!: NgForm;
  @ViewChild('auditForm') auditForm!: NgForm;
  @ViewChild('checklistForm') checklistForm!: NgForm;
  @ViewChild('balanceForm') balanceForm!: NgForm;
  @ViewChild('modalElement') modalElement!: ElementRef;

  auditProcess: any = null;
  filteredData: any = null;
  iSocietyDetailsId: number | null = null;
  iSocietyDetailsTransId: number | null = null;
  yearOptions: number[] = [];

  page = new Page();
  loading = false;
  Balancedatas: any[] = [];
  column: any[] = [];
  balanceSheet: any[] = [];
  head: any[] = [];
  allData: any = {};
  subheads: any[] = [];
  lstBussinessUpgrades: any[] = [];
  lstServiceData: any[] = [];
  selectedSubHeadNameValue: string = '';
  selectedServices: any[] = [];
  isAnyCheckboxChecked: boolean = false;
  fileName: string = '';
  GovtData: boolean = false;
  statuss: any;
  today: string = '';
  fileExtension: string = '';
  selectedFile: File | null = null;
  base64String2: string = '';
  base64String: string = '';
  lstAuditProcess: any;
  assetData: any[] = [];
  liabilityData: any[] = [];
  isReadOnly: boolean = false;
  hasSubmittedRemark = false;
  hasGovernmentShareCapital = false;
  download = false;
  isDisclaimerChecked: boolean = false;
  branches: boolean = false;
  isProfit = false;
  isLoss = false;
  trans: any;
  otherParams: any;
  auditMember: any;
  allotData: any;
  services: any;
  profitOrLoss: string = '';
  auditFeeCalculate: any;
  isFormValid = true;
  isEmployeeFormValid = true;
  isCommitteeFormValid = true;
  buttonDisable = false;
  rawBalanceData: any;
  asOnDate = '';
  building = {
    iSocietyDetailsTranID: 0,
    statusSocieties: '',
    iSocietyBuilding: false,
    buildingType: '',
    buildingRemarks: '',
    iLandDetailType: false,
    possessionType: '',
    landArea: null,
    landRemark: '',

    iSKindid: null,
  };
  empList = {
    iSocietyDetailsTranID: 0,
    totalMember: '',
    coOperativeSocietyNo: '',
    totalIndividualNo: '',
    maleMember: '',
    femaleMember: '',
    otherMember: '',
    generalMemberNo: '',
    oBCMemberNo: '',
    scMemberNo: '',
    stMemberNo: '',
    totalNoCommittee: '',
    totalPersonOnPositons: '',
    vacantPositions: '',
    totalNumberOfEmployess: '',
    trainedEmployees: '',
    nonTrainedEmployees: '',
    sectarytype: '',
    nonTrainedmember: '',
    trainedmember: '',
    generaltrainedEmployees: '',
    generalnonTrainedEmployees: '',
  };
  auditList = {
    sAuditYear: '',
    iSocietyDetailsTranID: 0,
    workingCapital: '',
    auditClassification: '',
    submissionDate: '',
    ghmDate: '',
    electionDate: '',
    auditStartDate: '',
  };
  balanceList = {
    BalanceSheetID: 0,
    iSocietyTransID: 0,
    type: 0,
    headID: 0,
    subHeadID: 0,
    subHead: '',
    Amount: '',
    asOnDate: '',
    UploadbalanceList: '',
    sUploadRD: '',
    sUploadpnL: '',
    FileNameUploadbalanceList: '',
    FileNamesUploadpnL: '',
    FileNamesUploadRD: ''
  };
  commanPerameter = {
    iSocietyDetailsTranID: 0,
    gstNo: '',
    panNo: '',
    tanNo: '',
    epfNo: '',
  };
  allotDatas = {
    auditAllotDate: '',
    fullName: '',
  };
  otherList = {
    iSocietyDetailsTranID: 0,
    branches: false,
    income: '',
    expenditure: '',
    auditFees: '',
    govtShare: '',
    redemptionOfGovtShare: '',
    govtDividentPayable: '',
    govtDividentPaid: '',
    govtLoan: '',
    recoveryOfPrincipal: '',
    recoveryOfInterest: '',
    misappropriationEmbezzlement: false,
    dateOfDetection: '',
    amountInvolved: '',
    specialReport: false,
    profit: '',
    loss: '',
    noOfBranches: '',
    bauditFees: '',
    remark: '',
    guarantee: false,
    auditTFees: '',
    totalamount: '',
    amountRecoverd: '',
    govtLoanPrincipal: '',
    govtLoanInterest: ''


  };
  newUpload = {
    documentPath: '',
    documentFileName: '',
    documentExtension: '',
    iSocietyDetailsTranID: 0,
    status: '',
    remark: '',
    iAllotAuditorID: 0,
  };
  cd: any;
  statusid: any;
  tempAuditYear: string = '';
  minDate!: string;
  maxDate!: string;
  voterListBase64: string = '';

  constructor(
    private finalchecklist: FinalChecklistService,
    private auditstatus: AuditStatusService,
    private router: Router,
    private auditService: AuditService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private alertService: SweetAlertService,
    private config: ConfigService,
    private allotService: AllotService,
    private sanitizer: DomSanitizer,
    private configService: ConfigService
  ) { }

  ngOnInit(): void {
    this.tempAuditYear = this.getPreviousAuditYear();
    this.GetCommanData();
    const today = new Date();
    const twentyYearsAgo = new Date(
      today.getFullYear() - 1,
      today.getMonth(),
      today.getDate()
    );
    this.statusid = this.auditstatus.getStatus();

    const now = new Date();
    this.today = now.toISOString().split('T')[0];
    this.route.paramMap.subscribe((params) => {
      const transId = params.get('iSocietyDetailsTransId');
      this.iSocietyDetailsTransId = transId ? +transId : 0;
      const id = params.get('iSocietyDetailsId');
      this.iSocietyDetailsId = id ? +id : null;
      if (
        this.iSocietyDetailsTransId !== null &&
        this.iSocietyDetailsId !== null
      ) {
        this.loadAuditors(this.iSocietyDetailsId, this.iSocietyDetailsTransId);
        this.GetAllData(this.iSocietyDetailsTransId);
        this.GetServices(this.iSocietyDetailsTransId);
      }
      this.onSubHeadChange();
      this.GetHeadData(this.balanceList.type);
      this.GetSubheadData(this.balanceList.headID);
      if (this.statusid == 0 || this.statusid == 1 || this.statusid == 4) {
        this.isReadOnly = false;
      } else if ((this.statusid = 3)) {
        this.isReadOnly = true;
        this.hasSubmittedRemark = true;
      }
    });
    {
      this.page.pageNumber = 0;
      this.page.pageSize = 10;
      this.page.totalRecords = 0;
    }
    const currentYear = new Date().getFullYear();
    this.minDate = `${currentYear}-01-01`;
    this.maxDate = `${currentYear}-12-31`;
    this.column = [
      { prop: 'headName', name: 'Head' },
      { prop: 'subHeadName', name: 'Sub-Head' },
      { prop: 'subHeadOther', name: 'Other' },
      { prop: 'amount', name: 'Amount' },
    ];
    this.setDefaultAsOnDate();
  }

  allowOnlyNonNegativeIntegers(event: KeyboardEvent): void {
    const key = event.key;

    if (
      ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'].includes(key)
    ) {
      return;
    }

    const input = event.target as HTMLInputElement;
    if (input.value.length === 0 && key === '0') {
      event.preventDefault();
      return;
    }

    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
    }
  }

  allowOnlyNonNegativePaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData?.getData('text') ?? '';

    // Disallow non-digits
    if (!/^\d+$/.test(pastedText)) {
      event.preventDefault();
      return;
    }

    // Disallow starting with 0 if length > 1
    if (pastedText.length > 1 && pastedText.startsWith('0')) {
      event.preventDefault();
    }
  }

  allowOnlyPositiveIntegers(event: KeyboardEvent): void {
    const key = event.key;

    // Allow control keys
    if (
      ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'].includes(key)
    ) {
      return;
    }

    // Allow digits 0–9
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
    }
  }
  getProgressPercentage(): number {
    if (!this.auditProcess || this.auditProcess.length === 0) return 0;

    const completedCount = this.auditProcess.filter(
      (p: any) => p.status === 'completed'
    ).length;
    return Math.round((completedCount / this.auditProcess.length) * 100);
  }

  onSubHeadChange(): void {
    const selected = this.subheads.find(
      (opt) => opt.id === +this.balanceList.subHeadID
    );
    this.selectedSubHeadNameValue = selected ? selected.name : '';
  }

  onFileChange(event: any, type: number): void {
    const file = event.target.files?.[0];
    if (!file) return;

    // const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
    const allowedExtensions = ['pdf'];

    const fileName = file.name;
    const fileExtension = this.getFileExtension(fileName).toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      this.toastService.showError(
        'Invalid file type. Allowed types: PDF.'
      );
      this.resetFileInput();
      return;
    }

    const fileSizeInMB = file.size / (1024 * 1024);
    if (fileSizeInMB > 2) {
      this.toastService.showError(
        'File size should be less than or equal to 2 MB.'
      );
      this.resetFileInput();
      return;
    }


    // All validations passed
    this.fileName = fileName;
    this.fileExtension = fileExtension;
    this.selectedFile = file;
    this.newUpload.documentPath = file;
    this.convertToBase64(file, type);
    this.cd.detectChanges();
  }
  resetFileInput(): void {
    this.newUpload.documentPath = '';
    this.fileName = '';
    this.fileExtension = '';
    this.selectedFile = null;

    const input = document.getElementById('UploadReport') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
  }
  sUploadpnL64: string = '';
  rDfile64: string = '';
  reportUpload: string = '';
  convertToBase64(file: File, from: number): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (from === 1) {
        this.base64String = reader.result as string;
        this.reportUpload = reader.result as string;

      }
      if (from === 2) {
        this.base64String2 = reader.result as string;
      }

      if (from === 3 || this.balanceList.UploadbalanceList) {
        this.balanceList.UploadbalanceList = reader.result as string;
        this.balanceList.FileNameUploadbalanceList = file.name;
        this.voterListBase64 = reader.result as string;
      }

      if (from === 4 || this.balanceList.sUploadpnL) {
        this.balanceList.sUploadpnL = reader.result as string;
        this.balanceList.FileNamesUploadpnL = file.name;
        this.sUploadpnL64 = reader.result as string;

      }

      if (from === 5 || this.balanceList.sUploadRD) {
        this.balanceList.sUploadRD = reader.result as string;
        this.balanceList.FileNamesUploadRD = file.name;
        this.rDfile64 = reader.result as string;

      }
    };
  }
  downloadDocument(fileName: string) {
    const fileUrl = this.configService.getFileUrl() + fileName;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    link.click();
  }
  errors: { [key: string]: string } = {};

  checkMaxLength(model: any, field: string, maxLength: number): void {
    const value = model[field];
    this.errors[field] = '';

    if (value && value.toString().length > maxLength) {
      this.errors[field] = `Value cannot exceed ${maxLength} characters.`;
    }
  }

  getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.');
    return lastDotIndex !== -1
      ? fileName.substring(lastDotIndex + 1).toLowerCase()
      : '';
  }

  validateNumber(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const charCode = event.which ? event.which : event.keyCode;
    const char = String.fromCharCode(charCode);

    // Allow only digits
    if (!/^\d$/.test(char)) {
      event.preventDefault();
      return;
    }

    const newValue = input.value + char;

    // Allow single 0, disallow leading zeros like 00, 01, etc.
    if (/^0\d+/.test(newValue)) {
      event.preventDefault();
    }
  }

  onPasteNumber(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text') || '';

    if (!/^\d+$/.test(pastedData)) {
      event.preventDefault();
    }
  }

  getPreviousAuditYear(): string {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    if (currentMonth >= 3) {
      return `${currentYear - 1}-${currentYear}`;
    } else {
      return `${currentYear - 2}-${currentYear - 1}`;
    }
  }

  GetAllData(iSocietyDetailsTranID: number) {
    this.finalchecklist
      .getlistDatas(iSocietyDetailsTranID)
      .subscribe((response) => {
        if (response.status === 200) {
          this.allData = response.data;

          this.auditFeeCalculate = this.allData.auditFee;

          this.auditProcess = response?.data?.auditProcess;
          this.trans = this.allData.societyDetailsTrans;
          this.otherParams = this.allData.finalOtherParameters;
          this.auditMember = this.allData.auditMemberDetails;

          this.building = {
            iSocietyDetailsTranID: this.trans?.iSocietyDetailsTranID,
            statusSocieties: this.trans?.statusSocieties || '',
            iSocietyBuilding: this.trans?.iSocietyBuilding || false,
            buildingType: this.trans?.buildingType || '',
            buildingRemarks: this.trans?.buildingRemarks || '',
            iLandDetailType: this.trans?.iLandDetailType || false,
            possessionType: this.trans?.possessionType || '',
            landArea: this.trans?.landArea || null,
            landRemark: this.trans?.landRemark || '',

            iSKindid: this.trans?.iSKindid || 0,
          };
          this.newUpload = {
            documentPath: this.trans?.auditorUploadedDocument || '',
            documentFileName: this.trans?.documentFileName || '',
            documentExtension: this.trans?.documentExtension || '',
            status: this.trans?.moveForwardToAR || '',
            iSocietyDetailsTranID: this.trans?.iSocietyDetailsTranID,
            remark: this.trans?.auditorRemark || '',
            iAllotAuditorID: this.trans?.iAllotAuditorID,
          };
          this.auditList = {
            sAuditYear: this.trans?.sAuditYear || this.getPreviousAuditYear(),
            iSocietyDetailsTranID: this.trans?.iSocietyDetailsTranID,
            workingCapital: this.trans?.workingCapital,
            auditClassification: this.trans?.auditClassification || null,
            submissionDate: this.formatDateToYYYYMMDD(
              this.trans?.submissionDate || ''
            ),
            ghmDate: this.formatDateToYYYYMMDD(this.trans?.ghmDate || ''),
            electionDate: this.formatDateToYYYYMMDD(
              this.trans?.electionDate || ''
            ),
            auditStartDate: this.formatDateToYYYYMMDD(
              this.trans?.auditStartDate || ''
            ),
          };

          this.otherList = {
            iSocietyDetailsTranID: this.otherParams?.iSocietyTransID || 0,
            income: this.otherParams?.income || '',
            totalamount: this.otherParams?.totalamount,
            auditTFees: this.otherParams?.auditTFees || '',
            expenditure: this.otherParams?.expenditure || '',
            govtLoanInterest: this.otherParams?.govtLoanInterest || '',
            govtLoanPrincipal: this.otherParams?.govtLoanPrincipal || '',
            amountRecoverd: this.otherParams?.amountRecoverd || '',
            auditFees: this.otherParams?.auditFees || '',
            govtShare: this.otherParams?.govtShare || '',
            redemptionOfGovtShare:
              this.otherParams?.redemptionOfGovtShare || '',
            govtDividentPayable: this.otherParams?.govtDividentPayable || '',
            govtDividentPaid: this.otherParams?.govtDividentPaid || '',
            govtLoan: this.otherParams?.govtLoan || '',
            recoveryOfPrincipal: this.otherParams?.recoveryOfPrincipal || '',
            recoveryOfInterest: this.otherParams?.recoveryOfInterest || '',
            misappropriationEmbezzlement:
              this.otherParams?.misappropriationEmbezzlement || false,
            amountInvolved: this.otherParams?.amountInvolved || '',
            specialReport: this.otherParams?.specialReport || '',
            dateOfDetection: this.formatDateToYYYYMMDD(
              this.otherParams?.dateOfDetection
            ),
            profit: this.otherParams?.profit || '',
            loss: this.otherParams?.loss || '',
            noOfBranches: this.otherParams?.noOfBranches || '',
            bauditFees: this.otherParams?.bauditFees || '',
            remark: this.otherParams?.remark || '',
            guarantee: this.otherParams?.guarantee || false,
            branches: this.otherParams?.branches || false,
          };
          if (this.otherParams?.noOfBranches) {
            this.otherList.branches = true;
          }
          this.empList = {
            iSocietyDetailsTranID: this.auditMember?.iSocietyDetailsTranID || 0,
            totalMember: this.auditMember.totalMember
              ? this.auditMember.totalMember
              : '',
            coOperativeSocietyNo: this.auditMember.coOperativeSocietyNo
              ? this.auditMember.coOperativeSocietyNo
              : '',
            totalIndividualNo: this.auditMember.totalIndividualNo
              ? this.auditMember.totalIndividualNo
              : '',
            maleMember: this.auditMember.maleMember
              ? this.auditMember.maleMember
              : '',
            otherMember: this.auditMember.otherMember
              ? this.auditMember.otherMember
              : '',
            femaleMember: this.auditMember.femaleMember
              ? this.auditMember.femaleMember
              : '',
            generalMemberNo: this.auditMember.generalMemberNo
              ? this.auditMember.generalMemberNo
              : '',
            oBCMemberNo: this.auditMember.obcMemberNo
              ? this.auditMember.obcMemberNo
              : '',
            scMemberNo: this.auditMember.scMemberNo
              ? this.auditMember.scMemberNo
              : '',
            stMemberNo: this.auditMember.stMemberNo
              ? this.auditMember.stMemberNo
              : '',
            totalNoCommittee: this.auditMember.totalNoCommittee
              ? this.auditMember.totalNoCommittee
              : '',
            totalPersonOnPositons: this.auditMember.totalPersonOnPositons
              ? this.auditMember?.totalPersonOnPositons
              : '',
            vacantPositions: this.auditMember.vacantPositions
              ? this.auditMember?.vacantPositions
              : '',
            totalNumberOfEmployess: this.auditMember.totalNumberOfEmployess
              ? this.auditMember.totalNumberOfEmployess
              : '',
            trainedEmployees: this.auditMember.trainedEmployees
              ? this.auditMember.trainedEmployees
              : '',
            nonTrainedEmployees: this.auditMember.nonTrainedEmployees
              ? this.auditMember.nonTrainedEmployees
              : '',
            sectarytype: this.auditMember?.sectarytype || '',
            nonTrainedmember: this.auditMember.nonTrainedmember
              ? this.auditMember.nonTrainedmember
              : '',
            trainedmember: this.auditMember.trainedmember
              ? this.auditMember.trainedmember
              : '',
            generalnonTrainedEmployees: this.auditMember
              .generalnonTrainedEmployees
              ? this.auditMember.generalnonTrainedEmployees
              : '',
            generaltrainedEmployees: this.auditMember.generaltrainedEmployees
              ? this.auditMember.generaltrainedEmployees
              : '',
          };

          this.rawBalanceData = this.allData.finalBalanceSheet || [];

          this.asOnDate = this.allData?.finalBalanceSheet?.[0]?.asOnDate || '';

          if (this.asOnDate) {
            this.balanceList.asOnDate = this.formatDateToYYYYMMDD(
              this.asOnDate
            );
          }

          this.Balancedatas = this.rawBalanceData.map((item: any) => ({
            balanceSheetID: item.balanceSheetID,
            headName: item.headName,
            subHeadName: item.subHeadName,
            subHeadOther: item.subHeadOther || '',
            amount: item.amount,
            type: item.type,
          }));
          if (this.rawBalanceData.length > 0) {
            this.processBalanceData(this.rawBalanceData);
          }
          this.hasGovernmentShareCapital = this.Balancedatas.some(
            (item) => item.subHeadName === 'Government Share Capital'
          );
          this.GovtData = this.hasGovernmentShareCapital;

          this.assetData = this.Balancedatas.filter(
            (item: any) => item.type === 2
          );

          this.liabilityData = this.Balancedatas.filter(
            (item: any) => item.type === 1
          );
          const allotData = this.allData.auditAllotmentDetails;
          this.allotDatas = {
            auditAllotDate: allotData?.auditAllotDate,
            fullName: allotData?.fullName,
          };
          const services = this.allData?.societyServiceDetails || {};

          this.commanPerameter = {
            iSocietyDetailsTranID: services?.iSocietyDetailsTranID ?? 0,
            gstNo: services[0]?.gstNo ?? '',
            panNo: services[0]?.panNo ?? '',
            tanNo: services[0]?.tanNo ?? '',
            epfNo: services[0]?.epfNo ?? '',
          };

          const fields: any[] = this.allData?.societyServiceDetailFields || [];

          let checkIds: any[] = [];
          fields.forEach((field) => {
            if (
              field?.checkd &&
              checkIds.indexOf(field.societyCheckID) === -1
            ) {
              checkIds.push(field.societyCheckID);
            }
          });

          checkIds.forEach(async (item, index) => {
            await this.Getfields(item);

            if (index == checkIds.length - 1) {
              this.setValue(fields);
            }
          });
        }
      });
  }
  setValue(fields: any) {
    setTimeout(() => {
      this.lstBussinessUpgrades.forEach((upgrade) => {
        const relatedFields = fields.filter(
          (f: any) => f.societyCheckID === upgrade.id
        );

        if (relatedFields.length > 0) {
          upgrade.checkd = true;

          relatedFields.forEach((field: any) => {
            // Map to lstServiceData
            upgrade.lstServiceData?.forEach((sub: any) => {
              if (
                sub.fieldID === field.fieldID &&
                (sub.value == null || sub.value === '')
              ) {
                sub.value = field.value;
              }
            });

            // Map to subFields
            upgrade.subFields?.forEach((sub: any) => {
              if (sub.subFieldID === field.subFieldID) {
                sub.value = field.value;
              }
            });

            // Map to groupedSubFields
            upgrade.groupedSubFields?.forEach((group: any) => {
              // Assign group heading if missing
              if (!group.heading && field.groupHeading) {
                group.heading = field.groupHeading;
              }

              // Set main field value
              if (group.fieldID === field.fieldID) {
                const inputType = group.inputType?.toLowerCase();

                if (inputType === 'dropdown') {
                  group.value = this.parseDropdownValue(inputType, field.value);
                } else if (inputType === 'boolean') {
                  const isGroupTrue =
                    group.value === true || group.value === 'true';

                  if (
                    isGroupTrue &&
                    Array.isArray(group.groupedConditionalFields)
                  ) {
                    group.groupedConditionalFields.forEach((subGroup: any) => {
                      if (Array.isArray(subGroup.fields)) {
                        subGroup.fields.forEach((condField: any) => {
                          const matched = relatedFields.find(
                            (f: any) =>
                              String(f.subFieldID) ===
                              String(condField.subFieldID)
                          );

                          if (matched && matched.hasOwnProperty('value')) {
                            condField.value = matched.value;
                          }
                        });
                      }
                    });
                  } else {
                    // When value is false or 'false' → hide fields and clear values
                    if (Array.isArray(group.groupedConditionalFields)) {
                      group.groupedConditionalFields.forEach(
                        (subGroup: any) => {
                          if (Array.isArray(subGroup.fields)) {
                            subGroup.fields.forEach((condField: any) => {
                              condField.value = '';
                            });
                          }
                        }
                      );
                    }
                  }
                } else {
                  group.value = field.value;
                }
              }

              group.groupedFields?.forEach((subGroup: any) => {
                subGroup.fields?.forEach((gfield: any) => {
                  if (gfield.fieldID === field.fieldID) {
                    gfield.value = field.value;
                  }
                });
              });

              group.conditionalFields?.forEach((condField: any) => {
                if (condField.fieldID === field.fieldID) {
                  condField.value = field.value;
                }
              });
            });
          });
        }
      });
    }, 1000);
  }
  parseDropdownValue(inputType: string, value: any): any {
    if (inputType?.toLowerCase() === 'dropdown' && value != null) {
      if (Array.isArray(value)) return value;

      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) return parsed;
        } catch (e) {
          return value
            .split(',')
            .map((v) => v.trim())
            .filter(Boolean);
        }
      }

      return [value];
    }
    return value;
  }

  GetCommanData(): void {
    this.auditService.getCommanDatas().subscribe(
      (response) => {
        if (response.status === 200) {
          this.statuss = response.data.status;
        }
      },
      (error) => { }
    );
  }
  updateTotalAuditFees(): void {
    const auditFee = Number(this.otherList.auditFees) || 0;
    const branchFee = Number(this.otherList.bauditFees) || 0;

    const total = auditFee + branchFee;

    this.otherList.auditTFees = total.toString();

  }
  formatDateToYYYYMMDD(dateStr: string | null | undefined): string {
    if (
      !dateStr ||
      dateStr.startsWith('0001-01-01') ||
      dateStr.startsWith('1900-01-01')
    ) {
      return '';
    }

    return dateStr.split('T')[0];
  }

  validateInput(event: KeyboardEvent, inputType: string): void {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);

    if (inputType === 'number') {
      if (!/^[0-9]$/.test(char)) {
        event.preventDefault();
      }
    } else if (inputType === 'string') {
      if (!/^[a-zA-Z0-9 ]$/.test(char)) {
        event.preventDefault();
      }
    }
    if (inputType === 'string' && event.target instanceof HTMLInputElement) {
      setTimeout(() => {
        const inputElement = event.target as HTMLInputElement;
        inputElement.value = inputElement.value.trim();
      });
    }
  }
  onPaste(event: ClipboardEvent, inputType: string): void {
    const pastedData = event.clipboardData?.getData('text') || '';

    if (inputType === 'number') {
      if (!/^\d+$/.test(pastedData)) {
        event.preventDefault();
      }
    }

    if (inputType === 'string') {
      if (!/^[a-zA-Z0-9 ]+$/.test(pastedData)) {
        event.preventDefault();
      }
    }
  }

  firstSetData: any;
  loadAuditors(iSocietyDetailsId: number, iSocietyDetailsTranID: number): void {
    this.finalchecklist
      .GetSocietyData(iSocietyDetailsId, iSocietyDetailsTranID)
      .subscribe(
        (response: any) => {
          if (response && response.data) {
            this.firstSetData = response.data;
            this.filteredData = this.firstSetData[0];
          }
        },
        (error) => {
          console.error('Error fetching society details:', error);
        }
      );
  }
  isSubmittingBuilding = false;

  submitBuildingForm() {
    if (this.BuildingformIsValid()) {
      this.isSubmittingBuilding = true;

      const transId = this.iSocietyDetailsTransId;
      this.building.iSocietyDetailsTranID = transId ?? 0;

      this.finalchecklist.addBuilding(this.building).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);
          this.goToTab('v-pills-MembersEmployeeDetails');
          this.isSubmittingBuilding = false;
        },
        (error) => {
          this.toastService.showError(
            error.message || 'Error while adding building.'
          );
          this.isSubmittingBuilding = false;
        }
      );
    }
  }

  formSubmitted = false;
  BuildingformIsValid(): boolean {
    // Check mandatory field
    if (
      !this.building.statusSocieties ||
      this.building.statusSocieties.trim() === ''
    ) {
      return false;
    }

    // Validate building-related fields
    if (this.building.iSocietyBuilding) {
      if (
        !this.building.buildingType ||
        !this.building.buildingRemarks ||
        this.building.buildingRemarks.trim() === ''
      ) {
        return false;
      }
    } else {
      // Reset building fields if not applicable
      this.building.buildingType = '';
      this.building.buildingRemarks = '';
    }

    // Validate land-related fields
    if (this.building.iLandDetailType) {
      if (
        !this.building.possessionType ||
        this.building.landArea == null ||
        this.building.landArea > 9999 ||
        !this.building.landRemark ||
        this.building.landRemark.trim() === ''
      ) {
        return false;
      }
    } else {
      this.building.possessionType = '';
      this.building.landArea = null;
      this.building.landRemark = '';
    }

    return true;
  }
  onLandDetailChange() {
    if (!this.building.iLandDetailType) {
      this.building.possessionType = '';
      this.building.landArea = null;
      this.building.landRemark = '';
    }
  }
  onBranchChange() {
    if (!this.branches) {
      this.otherList.noOfBranches = '';
      this.otherList.bauditFees = '';
    }
  }
  onMisappropriationChange() {
    if (!this.otherList.misappropriationEmbezzlement) {
      (this.otherList.dateOfDetection = ''),
        (this.otherList.amountInvolved = ''),
        (this.otherList.specialReport = false),
        (this.otherList.remark = '');
    }
    this.otherList.specialReport = false;
  }

  public hasIndividualMismatch: boolean = false;
  public hasCommitteeMismatch: boolean = false;
  public hasEmployeeMismatch: boolean = false;
  isEmpSubmitting = false;

  submitEmpForm() {
    const values = this.empForm.value;
    if (values.totalIndividualNo == 0) {
      this.toastService.showError('Total Individual cannot be zero');
      this.hasIndividualMismatch = true;

      return;
    } else if (values.totalNoCommittee == 0) {
      this.toastService.showError('Total commitee cannot be zero');
      this.hasCommitteeMismatch = true;

      return;
    } else if (values.totalNumberOfEmployess == 0) {
      this.toastService.showError('Total No. of Employees cannot be zero');
      this.hasEmployeeMismatch = true;

      return;
    }
    const safe = (val: any) => Number(val || 0);

    this.isFormValid = true;
    this.isEmployeeFormValid = true;
    this.isCommitteeFormValid = true;
    this.hasIndividualMismatch = false;
    this.hasEmployeeMismatch = false;
    this.hasCommitteeMismatch = false;
    this.buttonDisable = true;
    this.isEmpSubmitting = true;

    this.validateEmployeeTotals();
    this.validateCommitteeTotals();
    this.validateEmpTotals();

    const maleFemaleTotal = safe(values.maleMember) + safe(values.femaleMember) + safe(values.otherMember);
    const categoryTotal =
      safe(values.generalMemberNo) +
      safe(values.oBCMemberNo) +
      safe(values.scMemberNo) +
      safe(values.stMemberNo);
    // const generalTotal =
    //   safe(values.generaltrainedEmployees) +
    //   safe(values.generalnonTrainedEmployees);
    const totalIndividual = safe(values.totalIndividualNo);

    if (
      totalIndividual !== maleFemaleTotal ||
      totalIndividual !== categoryTotal

    ) {
      this.toastService.showError(
        'Please correct the mismatch in Total Individual Number compared to Gender and Category details.'
      );
      this.isFormValid = false;
      this.hasIndividualMismatch = true;
      this.buttonDisable = false;
      this.isEmpSubmitting = false;

      return;
    }

    if (this.hasCommitteeMismatch) {
      this.toastService.showError(
        'Total Committee Members mismatch. Check positions and training.'
      );
      this.isCommitteeFormValid = false;
      this.buttonDisable = false;
      this.isEmpSubmitting = false;

      return;
    }

    if (this.hasEmployeeMismatch) {
      this.toastService.showError(
        'Total Employees mismatch. Check Trained and Non-Trained counts.'
      );
      this.isEmployeeFormValid = false;
      this.buttonDisable = false;
      this.isEmpSubmitting = false;

      return;
    }

    if (
      this.isFormValid &&
      this.isEmployeeFormValid &&
      this.isCommitteeFormValid &&
      this.empListformIsValid()
    ) {
      this.buttonDisable = false;
      const transId = this.iSocietyDetailsTransId;
      this.empList.iSocietyDetailsTranID = transId ?? 0;
      this.finalchecklist.addEmp(this.empList).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);
          this.goToTab('v-pills-SocietyServices');
          this.isEmpSubmitting = false;
        },
        (error) => {
          this.toastService.showError(error.message);
          this.isEmpSubmitting = false;
        }
      );
    } else {
      this.toastService.showError(
        'Please submit all required fields correctly.'
      );
      this.buttonDisable = false;
      this.isEmpSubmitting = false;
    }
  }
  validateEmployeeTotals(
    field?: 'GM' | 'GF' | 'GOM' | 'GTM' | 'GNT' | 'GME' | 'OM' | 'SM' | 'STM'
  ) {
    const safe = (val: any): number => Math.max(parseInt(val || '0', 10), 0);

    let total = safe(this.empList.totalIndividualNo);

    let male = safe(this.empList.maleMember);
    let female = safe(this.empList.femaleMember);
    let other = safe(this.empList.otherMember);

    let gen = safe(this.empList.generalMemberNo);
    let obc = safe(this.empList.oBCMemberNo);
    let sc = safe(this.empList.scMemberNo);
    let st = safe(this.empList.stMemberNo);

    // let gTr = safe(this.empList.generaltrainedEmployees);
    // let gUnTr = safe(this.empList.generalnonTrainedEmployees);

    this.hasIndividualMismatch = false;


    if (['GM', 'GF', 'GO'].includes(field || '')) {

      const map = {
        GM: 'maleMember',
        GF: 'femaleMember',
        GO: 'otherMember'
      } as const;

      const changedKey = map[field as keyof typeof map];
      const currentVal = safe(this.empList[changedKey]);

      const otherKeys = Object.values(map).filter(k => k !== changedKey);

      const sumOthers = otherKeys.reduce(
        (sum, k) => sum + safe(this.empList[k]),
        0
      );


      if (total > 0 && currentVal + sumOthers > total) {
        this.hasIndividualMismatch = true;
        return;
      }

      const remaining = total - currentVal - sumOthers;

      const emptyKeys = otherKeys.filter(k => safe(this.empList[k]) === 0);

      // auto distribute remaining equally
      if (remaining > 0 && emptyKeys.length > 0) {

        const share = Math.floor(remaining / emptyKeys.length);
        let leftover = remaining - share * emptyKeys.length;

        for (const key of emptyKeys) {
          const val = share + (leftover > 0 ? 1 : 0);
          this.empList[key] = String(val);
          if (leftover > 0) leftover--;
        }
      }
    }


    // if (field === 'GTM') {
    //   gTr = safe(this.empList.generaltrainedEmployees);

    //   if (total > 0 && gTr <= total)
    //     this.empList.generalnonTrainedEmployees = String(total - gTr);
    //   else {
    //     this.hasIndividualMismatch = true;
    //     return;
    //   }
    // }

    // if (field === 'GNT') {
    //   gUnTr = safe(this.empList.generalnonTrainedEmployees);

    //   if (total > 0 && gUnTr <= total)
    //     this.empList.generaltrainedEmployees = String(total - gUnTr);
    //   else {
    //     this.hasIndividualMismatch = true;
    //     return;
    //   }
    // }


    if (['GME', 'OM', 'SM', 'STM'].includes(field || '')) {

      const map = {
        GME: 'generalMemberNo',
        OM: 'oBCMemberNo',
        SM: 'scMemberNo',
        STM: 'stMemberNo'
      } as const;

      const changedKey = map[field as keyof typeof map];
      const currentVal = safe(this.empList[changedKey]);

      const otherKeys = Object.values(map).filter(k => k !== changedKey);

      const sumOthers = otherKeys.reduce(
        (sum, k) => sum + safe(this.empList[k]),
        0
      );

      if (total > 0 && currentVal + sumOthers > total) {
        this.hasIndividualMismatch = true;
        return;
      }

      const remaining = total - currentVal - sumOthers;

      const emptyKeys = otherKeys.filter(k => safe(this.empList[k]) === 0);

      if (remaining > 0 && emptyKeys.length > 0) {

        const share = Math.floor(remaining / emptyKeys.length);
        let leftover = remaining - share * emptyKeys.length;

        for (const key of emptyKeys) {
          const val = share + (leftover > 0 ? 1 : 0);
          this.empList[key] = String(val);
          if (leftover > 0) leftover--;
        }
      }
    }


    male = safe(this.empList.maleMember);
    female = safe(this.empList.femaleMember);
    other = safe(this.empList.otherMember);

    gen = safe(this.empList.generalMemberNo);
    obc = safe(this.empList.oBCMemberNo);
    sc = safe(this.empList.scMemberNo);
    st = safe(this.empList.stMemberNo);

    // gTr = safe(this.empList.generaltrainedEmployees);
    // gUnTr = safe(this.empList.generalnonTrainedEmployees);

    const genderTotal = male + female + other;
    const categoryTotal = gen + obc + sc + st;
    // const trainedTotal = gTr + gUnTr;

    if (
      (total > 0 && genderTotal !== total) ||
      (total > 0 && categoryTotal !== total)
      // ||
      // (total > 0 && trainedTotal !== total)
    ) {
      this.hasIndividualMismatch = true;
    }
  }


  validateCommitteeTotals(sourceField?: 'TP' | 'VP' | 'TMN' | 'NTM') {
    const safe = (val: any): number => Math.max(parseInt(val || '0', 10), 0);

    let total = safe(this.empList.totalNoCommittee);
    let onPosition = safe(this.empList.totalPersonOnPositons);
    let vacant = safe(this.empList.vacantPositions);
    let trained = safe(this.empList.trainedmember);
    let untrained = safe(this.empList.nonTrainedmember);

    let calculatedValue = 0; // variable to hold calculated value

    switch (sourceField) {
      case 'TP': {
        if (!total && onPosition && vacant) {
          calculatedValue = onPosition + vacant;
          this.empList.totalNoCommittee = String(calculatedValue);
        } else if (total && onPosition) {
          calculatedValue = Math.max(total - onPosition, 0);
          this.empList.vacantPositions = String(calculatedValue);
        }
        break;
      }
      case 'VP': {
        if (!total && onPosition && vacant) {
          calculatedValue = onPosition + vacant;
          this.empList.totalNoCommittee = String(calculatedValue);
        } else if (total && vacant) {
          calculatedValue = Math.max(total - vacant, 0);
          this.empList.totalPersonOnPositons = String(calculatedValue);
        }
        break;
      }
      case 'TMN': {
        if (!total && trained && untrained) {
          calculatedValue = trained + untrained;
          this.empList.totalNoCommittee = String(calculatedValue);
        } else if (total && trained) {
          calculatedValue = Math.max(total - trained, 0);
          this.empList.nonTrainedmember = String(calculatedValue);
        }
        break;
      }
      case 'NTM': {
        if (!total && trained && untrained) {
          calculatedValue = trained + untrained;
          this.empList.totalNoCommittee = String(calculatedValue);
        } else if (total && untrained) {
          calculatedValue = Math.max(total - untrained, 0);
          this.empList.trainedmember = String(calculatedValue);
        }
        break;
      }
    }

    total = safe(this.empList.totalNoCommittee);
    onPosition = safe(this.empList.totalPersonOnPositons);
    vacant = safe(this.empList.vacantPositions);
    trained = safe(this.empList.trainedmember);
    untrained = safe(this.empList.nonTrainedmember);

    const totalByPosition = onPosition + vacant;
    const totalByTraining = trained + untrained;

    this.hasCommitteeMismatch = false;
    if (
      total <= 0 ||
      ((onPosition || vacant) && total !== totalByPosition) ||
      ((trained || untrained) && total !== totalByTraining)
    ) {
      this.hasCommitteeMismatch = true;
    }
  }

  validateEmpTotals(sourceField?: 'TE' | 'NTE') {
    const safe = (val: any): number => Math.max(parseInt(val || '0', 10), 0);

    let total = safe(this.empList.totalNumberOfEmployess);
    let trained = safe(this.empList.trainedEmployees);
    let untrained = safe(this.empList.nonTrainedEmployees);

    let calculatedValue = 0;

    switch (sourceField) {
      case 'TE': {
        if (trained && untrained && !total) {
          calculatedValue = trained + untrained;
          this.empList.totalNumberOfEmployess = String(calculatedValue);
        } else if (trained && total && total >= trained) {
          calculatedValue = total - trained;
          this.empList.nonTrainedEmployees = String(calculatedValue);
        }
        break;
      }

      case 'NTE': {
        if (trained && untrained && !total) {
          calculatedValue = trained + untrained;
          this.empList.totalNumberOfEmployess = String(calculatedValue);
        } else if (untrained && total && total >= untrained) {
          calculatedValue = total - untrained;
          this.empList.trainedEmployees = String(calculatedValue);
        }
        break;
      }

      default: {
        if (!total && trained && untrained) {
          this.empList.totalNumberOfEmployess = String(trained + untrained);
        } else if (total && trained && !untrained) {
          this.empList.nonTrainedEmployees = String(total - trained);
        } else if (total && !trained && untrained) {
          this.empList.trainedEmployees = String(total - untrained);
        }
        break;
      }
    }

    // Recalculate after autofill
    total = safe(this.empList.totalNumberOfEmployess);
    trained = safe(this.empList.trainedEmployees);
    untrained = safe(this.empList.nonTrainedEmployees);

    const totalExpected = trained + untrained;

    // Final mismatch validation
    this.hasEmployeeMismatch = false;
    if ((trained || untrained) && total !== totalExpected) {
      this.hasEmployeeMismatch = true;
    }
  }

  empListformIsValid() {
    return this.empForm && this.empForm.valid;
  }
  isAuditSubmitting = false;

  submitAuditForm() {
    const tempworkingcapital = +this.auditList.workingCapital;
    if (
      this.auditList.auditStartDate === 'yyyy-mm-dd' ||
      this.auditList.electionDate === 'yyyy-mm-dd' ||
      this.auditList.ghmDate === 'yyyy-mm-dd'
    ) {
      this.toastService.showError(
        'Please select valid dates for Audit Start Date, GHM Date, and Election Date.'
      );
      return;
    }

    if (this.auditListformIsValid()) {
      if (tempworkingcapital == 0) {
        setTimeout(() => {
          this.toastService.showError('Working Capital Always Greater then 0');
        }, 500);
        return;
      }
      this.isAuditSubmitting = true;

      const transId = this.iSocietyDetailsTransId;
      this.auditList.iSocietyDetailsTranID = transId ?? 0;
      this.auditList.sAuditYear = this.tempAuditYear;

      this.finalchecklist.addAudit(this.auditList).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);
          this.goToTab('v-pills-BalanceSheet');
          this.isAuditSubmitting = false;
        },
        (error) => {
          this.toastService.showError(error.message);
        }
      );
    } else {
      this.toastService.showError('Please fill out the required fields.');
      this.isAuditSubmitting = false;
    }
  }
  selectAll: boolean = false;

  toggleAllServices() {
    this.lstBussinessUpgrades.forEach(service => {
      service.checkd = this.selectAll;

      if (this.selectAll) {
        this.updateSelectedServices(service.id);
      } else {
        this.updateSelectedServices(service.id);
      }
    });
  }
  onCheckboxChanges(group: any, option: any, event: any) {
    if (!group.value) group.value = [];

    if (event.target.checked) {
      if (!group.value.includes(option)) {
        group.value.push(option);
      }
    } else {
      group.value = group.value.filter((x: any) => x !== option);
    }
  }
  toggleSelectAll(group: any, event: any) {
    if (event.target.checked) {
      group.value = [...group.options];
    } else {
      group.value = [];
    }
  }
  openPicker(picker: HTMLInputElement) {
    picker.showPicker?.();
    picker.focus();
  }

  isAllSelected(group: any): boolean {
    return group?.value?.length === group?.options?.length;
  }

  auditListformIsValid(): boolean {
    return (
      !!this.auditList.workingCapital &&
      !!this.auditList.auditStartDate &&
      !!this.auditList.submissionDate &&
      !!this.auditList.ghmDate

    );
  }

  next() {
    const totalLiability = this.calculateTotal(this.liabilityData);
    const totalAsset = this.calculateTotal(this.assetData);
    if (
      (!this.liabilityData ||
        this.liabilityData.length === 0 ||
        !this.assetData ||
        this.assetData.length === 0) &&
      !this.trans?.isLiquidatorRequest
    ) {
      this.toastService.showError(
        'At least one balance sheet entry is required.'
      );
      return;
    }

    if (this.totalLiability !== this.totalAsset) {
      this.toastService.showError(
        'Total Liabilities Amount must equal total Assets Amount.'
      );
      return;
    }

    this.goToTab('v-pills-OtherDetails');
  }

  calculateTotal(data: any[]): number {
    return data.reduce((sum, item) => sum + (parseInt(item.amount) || 0), 0);
  }

  get totalLiability(): number {
    return this.calculateTotal(this.liabilityData);
  }

  get totalAsset(): number {
    return this.calculateTotal(this.assetData);
  }

  isBalanceSubmitting = false;

  async addBalanceList(form: NgForm) {
    const tempAmount = +this.balanceList.Amount;

    // Step 1: Validate the form and custom method
    if (!form.valid || !this.balanceListformIsValid()) {
      Object.values(form.controls).forEach((control) =>
        control.markAsTouched()
      );
      this.toastService.showError('Please fill out the required fields.');
      return;
    }

    // Step 2: Amount should be > 0
    if (tempAmount === 0) {
      setTimeout(() => {
        this.toastService.showError('Amount must be greater than 0');
      }, 500);
      return;
    }

    const headSubExists = this.rawBalanceData.some(
      (item: any) =>
        item.headID === this.balanceList.headID &&
        item.subHeadID === this.balanceList.subHeadID
    );

    const headSubOtherExists = this.rawBalanceData.some(
      (item: any) =>
        item.headID === this.balanceList.headID &&
        item.subHeadID === this.balanceList.subHeadID &&
        item.subHeadOther === this.balanceList.subHead
    );

    if (headSubExists || headSubOtherExists) {
      const message =
        headSubOtherExists && headSubExists
          ? 'You have already added this Other Parameter Value. Do you still want to proceed?'
          : 'You have already added this Head and Sub-Head. Do you still want to proceed?';

      const confirmed = await this.alertService.confirmAlert(
        'Add BalanceSheet',
        message,
        'Submit',
        'No'
      );

      if (!confirmed) return;
    }

    this.isBalanceSubmitting = true;

    // Step 4: Assign transaction ID
    const transId = this.iSocietyDetailsTransId;
    this.balanceList.iSocietyTransID = transId ?? 0;

    // Step 5: Submit to API
    this.finalchecklist.addBalancesheet(this.balanceList).subscribe(
      (response) => {
        this.toastService.showSuccess(response.message);

        // Step 7: Reset form and reload
        form.resetForm();
        this.reset();
        this.resetfile();
        this.GetHeadData(this.balanceList.type);
        this.isBalanceSubmitting = false;

        if (this.iSocietyDetailsTransId !== null) {
          this.GetAllData(this.iSocietyDetailsTransId);
        }
      },
      (error) => {
        this.toastService.showError(error.message);
        this.isBalanceSubmitting = false;
      }
    );
  }
  resetfile() {
    this.voterListBase64 = '',
      this.rDfile64 = '',
      this.sUploadpnL64 = ''
  }
  setDefaultAsOnDate() {


    if (!this.balanceList.asOnDate) {
      const now = new Date();
      const y = now.getMonth() > 2 ? now.getFullYear() + 1 : now.getFullYear();
      this.balanceList.asOnDate = `${y}-03-31`;
    }
  }

  base64ToBlob(base64: any, contentType = "", sliceSize = 512): Blob {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }
  selectedContent: string = '';
  base64Pdf: SafeResourceUrl = '';
  previewFile(file: any, model: any): void {

    if (!file) return;
    const blob = this.base64ToBlob(file, "application/pdf");
    this.base64Pdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
    this.openModals(model)
  }
  openModals(content: string): void {
    this.selectedContent = content;
    const modalElement = document.getElementById(content);
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  }

  reset() {
    this.balanceList = {
      BalanceSheetID: 0,
      iSocietyTransID: 0,
      type: 0,
      headID: 0,
      subHeadID: 0,
      subHead: '',
      Amount: '',
      asOnDate: '',
      UploadbalanceList: '',
      sUploadRD: '',
      sUploadpnL: '',
      FileNameUploadbalanceList: '',
      FileNamesUploadpnL: '',
      FileNamesUploadRD: ''
    };
    this.head = [];
    this.subheads = [];
    this.selectedSubHeadNameValue = '';
  }

  balanceListformIsValid(): boolean {
    this.formSubmitted = true;
    let isValid = true;
    const isAsOnDateVisible = !this.rawBalanceData.length;

    if (isAsOnDateVisible) {
      if (
        !this.balanceList.asOnDate
        // this.validateDate(this.balanceList.asOnDate) !== null
      ) {
        isValid = false;
      }
    }

    if (
      !this.balanceList.type ||
      !this.balanceList.headID ||
      !this.balanceList.subHeadID ||
      !this.balanceList.Amount
    ) {
      isValid = false;
    }

    if (this.selectedSubHeadNameValue === 'Other') {
      if (!this.balanceList.subHead || this.balanceList.subHead.trim() === '') {
        isValid = false;
      }
    }

    return isValid;
  }

  GetHeadData(headType: number): void {
    this.finalchecklist.getheadDatas(headType).subscribe(
      (response) => {
        if (response.status === 200) {
          this.head = response.data;

          this.balanceList.headID = 0;

          this.balanceList.subHeadID = 0;
        }
      },
      (error) => {
        console.error('Error fetching head data', error);
      }
    );
  }

  GetSubheadData(headID: any): void {
    this.finalchecklist.getsubheadDatas(headID).subscribe(
      (response) => {
        if (response.status === 200) {
          if (this.filteredData?.level === 'Primary') {
            this.subheads = response.data.filter(
              (item: any) => item.name !== 'By Cooperatives'
            );
          } else {
            this.subheads = response.data;

            this.balanceList.subHeadID = 0;
          }
        }
      },
      (error) => {
        console.error('Error fetching subhead data', error);
      }
    );
  }

  GetServices(iSocietyDetailstId: number): void {
    this.iSocietyDetailsTransId = iSocietyDetailstId;
    this.finalchecklist.getservicesDatas(iSocietyDetailstId).subscribe(
      (response) => {
        if (response.status === 200) {
          this.lstBussinessUpgrades = response.data;
        }
      },
      (error) => {
        console.error('Error fetching data', error);
      }
    );
  }
  isChecklistSubmitting = false;

  submitChecklistValue(): void {
    if (!this.formsturnIsValid()) {
      this.toastService.showError('Please fill out all required fields.');
      return;
    }
    const selectedServices = (this.lstBussinessUpgrades || []).filter(
      (service) => service.checkd
    );

    if (!Array.isArray(selectedServices) || selectedServices.length === 0) {
      this.toastService.showError('Please select at least one service.');
      return;
    }
    this.isChecklistSubmitting = true;

    const transId = this.iSocietyDetailsTransId;
    this.commanPerameter.iSocietyDetailsTranID = transId ?? 0;

    const getFieldID = (item: any): number =>
      item.fieldID ?? item.iTBussinessFieldID ?? 0;

    const getSubFieldID = (item: any): number =>
      item.subFieldID ?? item.iTSubFieldID ?? item.subField?.id ?? 0;

    const serviceList = (this.lstBussinessUpgrades || [])
      .filter((service) => service.checkd)
      .flatMap((service) => {
        const allFields: any[] = [];

        (service.groupedSubFields || []).forEach((group: any) => {
          const headingName = group.heading || '';

          if (group.fields?.length > 0) {
            // 🧩 Handle grouped fields
            group.fields.forEach((subField: any) => {
              if (Array.isArray(subField.value)) {
                subField.value.forEach((val: any) => {
                  allFields.push({
                    societyCheckID: service.id,
                    fieldID: getFieldID(subField),
                    subFieldID: getSubFieldID(subField),
                    headingName,
                    value: String(val).trim(),
                  });
                });
              } else {
                allFields.push({
                  societyCheckID: service.id,
                  fieldID: getFieldID(subField),
                  subFieldID: getSubFieldID(subField),
                  headingName,
                  value:
                    subField.value != null ? String(subField.value).trim() : '',
                });
              }
            });

            if (group.groupedConditionalFields?.length > 0) {
              group.groupedConditionalFields.forEach((condGroup: any) => {
                condGroup.fields?.forEach((cond: any) => {
                  allFields.push({
                    societyCheckID: service.id,
                    fieldID: getFieldID(cond),
                    subFieldID: getSubFieldID(cond),
                    headingName: condGroup.heading || headingName,
                    value: cond.value != null ? String(cond.value).trim() : '',
                  });
                });
              });
            }
          } else {
            allFields.push({
              societyCheckID: service.id,
              fieldID: getFieldID(group),
              subFieldID: getSubFieldID(group),
              headingName,
              value: group.value != null ? String(group.value).trim() : '',
            });

            if (group.groupedConditionalFields?.length > 0) {
              group.groupedConditionalFields.forEach((condGroup: any) => {
                condGroup.fields?.forEach((cond: any) => {
                  allFields.push({
                    societyCheckID: service.id,
                    fieldID: getFieldID(cond),
                    subFieldID: getSubFieldID(cond),
                    headingName: condGroup.heading || headingName,
                    value: cond.value != null ? String(cond.value).trim() : '',
                  });
                });
              });
            }
          }
        });

        return allFields;
      });

    const requestData = {
      iSocietyDetailsTranID: this.commanPerameter.iSocietyDetailsTranID ?? 0,
      gstNo: this.commanPerameter.gstNo?.trim() || '',
      panNo: this.commanPerameter.panNo?.trim() || '',
      tanNo: this.commanPerameter.tanNo?.trim() || '',
      epfNo: this.commanPerameter.epfNo?.trim() || '',
      lst: serviceList,
    };

    this.finalchecklist.addservices(requestData).subscribe({
      next: (response) => {
        this.toastService.showSuccess(
          response?.message || 'Submitted successfully.'
        );
        this.updateSelectedServicesList(response);
        this.goToTab('v-pills-AuditDetails');
        this.isChecklistSubmitting = false;
      },
      error: (error) => {
        this.toastService.showError(
          error?.message || 'An error occurred while submitting.'
        );
        this.isChecklistSubmitting = false;
      },
    });
  }

  formsturnIsValid() {
    return this.checklistForm && this.checklistForm.valid;
  }
  allowOnlyNonNumeric(event: KeyboardEvent): boolean {
    const charCode = event.key;
    if (/\d/.test(charCode)) {
      event.preventDefault();
      return false;
    }
    return true;
  }
  back() {
    window.history.back();
  }
  Getfields(societyCheckID: number) {
    return this.finalchecklist.getfieldsDatas(societyCheckID).subscribe({
      next: (response) => {
        if (response.status === 200) {
          const selectedService = this.lstBussinessUpgrades.find(
            (ser) => ser.id === societyCheckID
          );

          if (selectedService) {
            selectedService.lstServiceData = response.data;

            this.finalchecklist.getsubfieldsDatas(societyCheckID).subscribe({
              next: (subResponse) => {
                selectedService.subFields = subResponse.data;

                const grouped = selectedService.lstServiceData.map(
                  (main: any) => {
                    if (!main?.inputType) {
                      return {
                        heading: main.labelName,
                        fieldID: main.fieldID,
                        value: main?.value || '',
                        fields: selectedService.subFields.filter(
                          (sub: any) => sub.fieldID === main.fieldID
                        ),
                      };
                    } else if (main?.inputType == 'dropdown') {
                      let options = selectedService.subFields
                        .filter((sub: any) => sub.fieldID === main.fieldID)
                        .map((f: any) => {
                          return f?.labelName || '';
                        });

                      return {
                        heading: main.labelName,
                        fieldID: main.fieldID,
                        options: options,
                        inputType: main?.inputType,
                      };
                    } else if (main?.inputType === 'boolean') {
                      const booleanFields = selectedService.subFields.filter(
                        (sub: any) => sub.fieldID === main.fieldID
                      );

                      const groupedConditionalFields = booleanFields.reduce(
                        (acc: any[], field: any) => {
                          const heading = field.headingName || 'General';
                          let group = acc.find((g) => g.heading === heading);
                          if (!group) {
                            group = { heading, fields: [] };
                            acc.push(group);
                          }
                          group.fields.push({
                            labelName: field.labelName,
                            headingName: field.headingName,
                            headingFlag: field.headingFlag,
                            inputType: 'number',
                            value: field.value || '',
                            isRequired: field.isRequired || false,
                            fieldID:
                              field.fieldID ?? field.iTBussinessFieldID ?? 0,
                            subFieldID:
                              field.subFieldID ??
                              field.iTSubFieldID ??
                              field.subField?.id ??
                              0,
                          });
                          return acc;
                        },
                        []
                      );

                      return {
                        heading: main.labelName,
                        fieldID: main.fieldID,
                        inputType: 'boolean',
                        // value: main?.value,
                        value: true,
                        fields: [],
                        groupedConditionalFields,
                      };
                    } else {
                      return main;
                    }
                  }
                );

                const groupedFieldIDs = grouped.flatMap(
                  (g: any) => g.fields && g.fields.map((f: any) => f.id)
                );

                selectedService.groupedSubFields = grouped;
              },
              error: (err) => {
                console.error('Error fetching sub-fields:', err);
              },
            });
          }
        }
        return;
      },
      error: (error) => {
        console.error('Error fetching fields:', error);
      },
    });
  }
  updateTotals() {
    this.lstBussinessUpgrades.forEach((service) => {
      service.groupedSubFields?.forEach((group: any) => {
        let controlledQty = 0;
        let nonControlledQty = 0;
        let controlledAmt = 0;
        let nonControlledAmt = 0;

        group.fields?.forEach((field: any) => {
          if (Array.isArray(field.subFields)) {
            field.subFields.forEach((sub: any) => {
              const subLabel = sub.labelName?.trim() || '';
              const subValRaw = sub.value?.toString().trim();
              const subVal =
                subValRaw && !isNaN(Number(subValRaw))
                  ? parseInt(subValRaw, 10)
                  : 0;

              switch (subLabel) {
                case 'Quality of Controlled Items':
                  controlledQty += subVal;
                  break;
                case 'Quality of Non - Controlled Items':
                  nonControlledQty += subVal;
                  break;
                case 'Amt of Controlled Item':
                  controlledAmt += subVal;
                  break;
                case 'Amt of Non-Controlled Item':
                  nonControlledAmt += subVal;
                  break;
              }
            });
          }
        });

        const totalQty = controlledQty + nonControlledQty;
        const totalAmt = controlledAmt + nonControlledAmt;

        // Assign computed totals
        group.fields?.forEach((field: any) => {
          const label = field.labelName?.trim();

          if (label === 'Total Quantity(MT)') {
            field.value = totalQty.toString(); // Set as string if required
          }
          if (label === 'Total Amount') {
            field.value = totalAmt.toString();
          }
        });
      });
    });
  }

  updateSelectedServicesList(response: any): void {
    if (!response || !Array.isArray(response.societyServiceRequests)) return;

    response.societyServiceRequests.forEach((serviceReq: any) => {
      const service = this.lstBussinessUpgrades.find(
        (ser) => ser.id === serviceReq.iBussinessSerID
      );
      if (service) {
        const allFields = [
          ...(service.lstServiceData || []),
          ...(service.subFields || []),
        ];
        const field = allFields.find(
          (f) => f.fieldID === serviceReq.iTBussinessFieldID
        );
        if (field) {
          field.value = serviceReq.value;
          field.isRequired = serviceReq.isRequired ?? false;
        }
      }
    });
  }

  onCheckboxChange(): void {
    this.isAnyCheckboxChecked = this.lstBussinessUpgrades.some(
      (ser) => ser.checkd
    );
  }

  updateSelectedServices(id: number): void {
    const selectedService = this.lstBussinessUpgrades.find(
      (service: { id: number }) => service.id === id
    );

    if (selectedService) {
      this.Getfields(selectedService.id);
    } else {
      console.error('No valid service found for ID:', id);
      this.selectedServices = [];
    }
  }
  isOtherSubmitting = false;

  async addOtherList() {
    this.formSubmitted = true;
    const tempIncome = Number(this.otherList.income);
    const tempexp = Number(this.otherList.expenditure);
    const totalLiability = this.calculateTotal(this.liabilityData);
    const totalAsset = this.calculateTotal(this.assetData);

    if (this.totalLiability !== this.totalAsset) {
      this.toastService.showError(
        'Total Liabilities Amount must equal total Assets Amount.'
      );
      return;
    }

    if (!this.BuildingformIsValid()) {
      this.goToTab('v-pills-SocietyInformation');
      this.toastService.showError(
        'Please fill required Society Information details.'
      );
      return;
    }

    if (!this.empListformIsValid()) {
      this.goToTab('v-pills-MembersEmployeeDetails');
      this.toastService.showError(
        'Please fill required Members/Employee Details.'
      );
      return;
    }

    if (!this.auditListformIsValid()) {
      this.goToTab('v-pills-AuditDetails');
      this.toastService.showError('Please fill required Audit Details.');
      return;
    }

    if (!this.isFormDataValid()) {
      this.goToTab('v-pills-OtherDetails');
      this.toastService.showError('Please fill required Other Details.');
      return;
    }
    if (tempIncome === 0) {
      setTimeout(() => {
        this.toastService.showError('Income must be greater than 0');
      }, 500);
      return;
    }
    if (tempexp === 0) {
      setTimeout(() => {
        this.toastService.showError('Expenditure must be greater than 0');
      }, 500);
      return;
    }
    const confirmed = await this.alertService.confirmAlert(
      'Audit Checklist',
      'Are you sure you want to submit  Checklist?',
      'Submit',
      'No'
    );

    if (!confirmed) {
      return;
    }
    this.isOtherSubmitting = true;

    const transId = this.iSocietyDetailsTransId;
    this.otherList.iSocietyDetailsTranID = transId ?? 0;

    const payload: any = {
      iSocietyDetailsTranID: this.otherList.iSocietyDetailsTranID || 0,
      Income: this.otherList.income,
      Expenditure: this.otherList.expenditure,
      AuditFees: this.otherList.auditFees.toString(),
      Profit: this.otherList.profit,
      Loss: this.otherList.loss,
      noOfBranches: this.otherList.noOfBranches,
      bauditFees: this.otherList.bauditFees,
      MisappropriationEmbezzlement: this.otherList.misappropriationEmbezzlement,
      remark: this.otherList.remark,
      guarantee: this.otherList.guarantee,
      branches: this.otherList.branches,
    };

    if (this.otherList.misappropriationEmbezzlement === true) {
      payload.amountInvolved = this.otherList.amountInvolved || '';
      payload.SpecialReport = this.otherList.specialReport || false;
      payload.dateOfDetection = this.otherList.dateOfDetection || '';
      payload.amountRecoverd = this.otherList.amountRecoverd || ''
    }
    if (this.otherList.branches === true) {
      payload.noOfBranches = this.otherList.noOfBranches || '';
      payload.bauditFees = this.otherList.bauditFees || '';
      payload.auditTFees = this.otherList.auditTFees || '';
    }
    if (this.otherList.guarantee === true) {
      payload.totalamount = this.otherList.totalamount || '';

    }

    if ((this.selectedSubHeadNameValue = 'Government Share Capital')) {
      payload.GovtShare = this.otherList.govtShare;
      payload.RedemptionOfGovtShare = this.otherList.redemptionOfGovtShare;
      payload.GovtDividentPayable = this.otherList.govtDividentPayable;
      payload.GovtDividentPaid = this.otherList.govtDividentPaid;
      payload.GovtLoan = this.otherList.govtLoan;
      payload.RecoveryOfPrincipal = this.otherList.recoveryOfPrincipal;
      payload.RecoveryOfInterest = this.otherList.recoveryOfInterest;
      payload.govtLoanPrincipal = this.otherList.govtLoanPrincipal;
      payload.govtLoanInterest = this.otherList.govtLoanInterest;
    } else {
      payload.GovtShare = '';
      payload.RedemptionOfGovtShare = '';
      payload.GovtDividentPayable = '';
      payload.GovtDividentPaid = '';
      payload.GovtLoan = '';
      payload.RecoveryOfPrincipal = '';
      payload.RecoveryOfInterest = '';
      payload.govtLoanPrincipal = '';
      payload.govtLoanInterest = '';
    }

    this.finalchecklist.addotherList(payload).subscribe(
      (response) => {
        // this.toastService.showSuccess(response.message);
        this.newUpload = {
          documentPath: '',
          documentFileName: '',
          documentExtension: '',
          iSocietyDetailsTranID: 0,
          status: '',
          remark: '',
          iAllotAuditorID: 0,
        };

        const modalElement = document.getElementById('checklistStatus');
        if (modalElement) {
          const modal = new bootstrap.Modal(modalElement);

          this.newUpload = {
            // documentPath: this.trans?.auditorUploadedDocument
            //   ? this.trans.auditorUploadedDocument.split('\\').pop()
            //   : '',
            documentPath: '',
            documentFileName: this.trans?.documentFileName || '',
            documentExtension: this.trans?.documentExtension || '',
            status: this.trans?.moveForwardToAR ? 'MoveForward' : '',
            iSocietyDetailsTranID: this.trans?.iSocietyDetailsTranID,
            remark: this.trans?.auditorRemark || '',
            iAllotAuditorID: this.trans?.iAllotAuditorID,
          };

          modal.show();
          this.isOtherSubmitting = false;
        }
      },
      (error) => {
        this.toastService.showError(error.message);
        this.isOtherSubmitting = false;
      }
    );
  }

  goToTab(tabId: string) {
    const triggerEl = document.querySelector(
      `[data-bs-target="#${tabId}"]`
    ) as HTMLElement;
    if (triggerEl) {
      const tab = new bootstrap.Tab(triggerEl);
      tab.show();
    }
  }

  isFormDataValid(): boolean {

    let isValid = true;
    // const totalLiability = this.calculateTotal(this.liabilityData);
    // const totalAsset = this.calculateTotal(this.assetData);
    // if (
    //   (!this.liabilityData ||
    //     this.liabilityData.length === 0 ||
    //     !this.assetData ||
    //     this.assetData.length === 0) &&
    //   !this.trans?.isLiquidatorRequest
    // ) {
    //   this.toastService.showError(
    //     'At least one balance sheet entry is required.'
    //   );
    //   isValid = true;
    //   return isValid;
    // }

    // --- Always required fields ---
    if (
      !this.otherList.income ||
      !this.otherList.expenditure ||
      !this.otherList.auditFees
    ) {
      isValid = false;
    }

    // --- Misappropriation must be boolean ---
    const isMisappropriationBoolean =
      this.otherList.misappropriationEmbezzlement === true ||
      this.otherList.misappropriationEmbezzlement === false;

    if (!isMisappropriationBoolean) {
      isValid = false;
    }

    // --- Govt fields (if applicable) ---
    if (this.GovtData) {
      const govtFields = [
        this.otherList.govtShare,
        this.otherList.redemptionOfGovtShare,
        this.otherList.govtDividentPayable,
        this.otherList.govtDividentPaid,
        this.otherList.govtLoan,
        this.otherList.recoveryOfPrincipal,
        this.otherList.recoveryOfInterest,
      ];
      if (govtFields.some((field) => field == null || field === '')) {
        isValid = false;
      }
    }

    // --- Misappropriation details (if true) ---
    if (this.otherList.misappropriationEmbezzlement === true) {
      const hasDate = !!this.otherList.dateOfDetection;
      const hasAmount = !!this.otherList.amountInvolved;
      const remark = (this.otherList.remark || '').trim();
      const specialReportBoolean =
        this.otherList.specialReport === true ||
        this.otherList.specialReport === false;

      if (!hasDate || !hasAmount || !specialReportBoolean || !remark) {
        isValid = false;
      }
    }

    // --- Branch‐related fields only if branches === true ---
    if (this.otherList.branches === true) {
      // must have non‐empty number of branches
      if (
        this.otherList.noOfBranches == null ||
        this.otherList.noOfBranches === ''
      ) {
        isValid = false;
      }
      // must have branch audit fees
      if (
        this.otherList.bauditFees == null ||
        this.otherList.bauditFees === ''
      ) {
        isValid = false;
      }
    }

    return isValid;
  }

  isStatusSubmitting = false;

  UpdateStatus() {
    if (!this.StatusFormValid()) {
      this.toastService.showError('Form is invalid.');
      return;
    }
    this.isStatusSubmitting = true;

    const transId = this.iSocietyDetailsTransId ?? 0;
    const id = this.iSocietyDetailsId ?? 0;

    this.newUpload.iSocietyDetailsTranID = transId;
    this.newUpload.documentPath = this.base64String || '';
    this.newUpload.documentFileName = this.fileName;
    this.newUpload.documentExtension = this.fileExtension;
    this.newUpload.iAllotAuditorID = this.trans?.iAllotAuditorID;

    this.auditService.StatusUpdat(this.newUpload, id).subscribe({
      next: (res: any) => {
        this.isStatusSubmitting = false;

        if (res.status === 200) {
          this.toastService.showSuccess(res.message);
          this.router.navigate([`/dashboard`]);
        } else {
          this.toastService.showError('Failed to update status.');
        }
      },
      error: (err) => {
        this.isStatusSubmitting = false;

        this.toastService.showError(err.message || 'Failed to update status.');
      },
    });
  }

  restStatus() {
    this.newUpload = {
      documentPath: '',
      documentFileName: '',
      documentExtension: '',
      iSocietyDetailsTranID: 0,
      status: '',
      remark: '',
      iAllotAuditorID: 0,
    };
  }
  StatusFormValid(): boolean {
    const trimmedRemark = this.newUpload.remark
      ? this.newUpload.remark.trim()
      : '';

    return !!(
      this.newUpload.documentPath &&
      this.newUpload.status &&
      trimmedRemark &&
      this.isDisclaimerChecked
    );
  }

  // validateDate(dateStr: string): string | null {
  //   const date = new Date(dateStr);
  //   const min = new Date(this.minDate);
  //   const max = new Date(this.maxDate);
  //   if (isNaN(date.getTime())) return null;
  //   if (date < min) return 'min';
  //   if (date > max) return 'max';
  //   return null;
  // }
  updateAuditClassification(): void {
    const wc = Number(this.auditList.workingCapital);
    if (!wc || isNaN(wc)) {
      this.auditList.auditClassification = '';
      return;
    }

    const wcInLakhs = wc / 100000;

    if (wcInLakhs >= 300) {
      this.auditList.auditClassification = 'AA';
    } else if (wcInLakhs >= 150 && wcInLakhs < 300) {
      this.auditList.auditClassification = 'A';
    } else if (wcInLakhs >= 75 && wcInLakhs < 150) {
      this.auditList.auditClassification = 'B';
    } else if (wcInLakhs > 15 && wcInLakhs < 75) {
      this.auditList.auditClassification = 'C';
    } else {
      this.auditList.auditClassification = 'D';
    }
  }

  calculateProfitOrLoss(): void {
    // 1. Parse inputs
    const income = Number(this.otherList.income ?? 0);
    const expenditure = Number(this.otherList.expenditure ?? 0);

    // 2. Reset string‑typed fields
    this.otherList.profit = '';
    this.otherList.loss = '';
    this.otherList.auditFees = '';
    this.isProfit = false;
    this.isLoss = false;

    // 3. Profit case
    if (income > expenditure) {
      const profitNum = income - expenditure;
      this.otherList.profit = profitNum.toString(); // string ← number
      this.isProfit = true;
      this.isLoss = false;

      this.calculateProfit(); // will set auditFees as string

      // 4. Loss case
    } else if (expenditure > income) {
      const lossNum = expenditure - income;
      this.otherList.loss = lossNum.toString(); // string ← number
      this.isLoss = true;
      this.isProfit = false;

      this.calculateLoss(); // you’ll need a matching method to compute auditFees

      // 5. Break‑even case
    } else {
      const minFee = Number(this.auditFeeCalculate?.minimun ?? 0);
      this.otherList.auditFees = minFee.toString(); // string ← number
      this.isProfit = false;
      this.isLoss = false;
    }
  }

  calculateProfit(): void {
    const income = Number(this.otherList.income) || 0;
    const profit = Number(this.otherList.profit) || 0;
    const {
      rateOfProfit = 1,
      maximun = 0,
      minimun = 0,
    } = this.auditFeeCalculate || {};

    this.otherList.auditFees = '';

    // 3. Validate profit ≤ income
    if (profit > income) {
      this.toastService.showError(
        'Profit must be less than or equal to Income'
      );
      return;
    }

    // 4. Calculate average amount
    const avgAmount = profit / rateOfProfit;

    // 5. Determine fee (as number)
    let feeNumber: number;
    if (avgAmount >= maximun) {
      feeNumber = maximun;
    } else if (avgAmount <= minimun) {
      feeNumber = minimun;
    } else {
      feeNumber = avgAmount;
    }

    this.otherList.auditFees = feeNumber.toString();
  }

  calculateLoss() {
    const expenditure = Number(this.otherList.expenditure);
    const loss = Number(this.otherList.loss);
    const auditFeeCal = this.auditFeeCalculate;
    this.otherList.auditFees = auditFeeCal.minimun;
    if (loss > expenditure) {
      this.otherList.auditFees = auditFeeCal.minimun;
    }
    this.otherList.auditFees = auditFeeCal.minimun;
  }
  isGovtshare: boolean = false;
  processBalanceData(entries: any[]) {
    this.otherList.profit = '';
    this.otherList.loss = '';
    this.otherList.govtShare = '';

    this.isProfit = false;
    this.isLoss = false;
    this.isGovtshare = false;

    let profitSet = false;
    let lossSet = false;

    for (const value of entries) {
      if (!value) continue;

      const headID = value.headID;
      const subHeadID = value.subHeadID;

      const isProfitMatch = headID === 6 && subHeadID === 34;
      const isLossMatch = headID === 17 && subHeadID === 62;
      const isGovtshare = headID === 1 && subHeadID === 2;

      if (isGovtshare) {
        this.otherList.govtShare = value.amount || '';
        this.isGovtshare = true;
      }

      if (!profitSet && isProfitMatch) {
        this.otherList.profit = value.amount || '';
        this.isProfit = true;
        profitSet = true;
      }

      if (!lossSet && isLossMatch) {
        this.otherList.loss = value.amount || '';
        this.isLoss = true;
        lossSet = true;
      }
    }

    this.calAuditFees();
  }
  calAuditFees(): void {

    const profit = Number(this.otherList.profit) || 0;
    const loss = Number(this.otherList.loss) || 0;

    const {
      rateOfProfit = 1,
      maximun = 0,
      minimun = 0,
    } = this.auditFeeCalculate || {};

    this.otherList.auditFees = '';
    this.isProfit = false;
    this.isLoss = false;

    // ✅ PROFIT CASE
    if (profit > 0) {

      this.isProfit = true;
      this.isLoss = false;

      const avgAmount = profit / rateOfProfit;

      let feeNumber: number;

      if (avgAmount >= maximun) {
        feeNumber = maximun;
      } else if (avgAmount <= minimun) {
        feeNumber = minimun;
      } else {
        feeNumber = avgAmount;
      }

      this.otherList.auditFees = feeNumber.toString();
    }

    else if (loss > 0) {

      this.isLoss = true;
      this.isProfit = false;

      this.otherList.auditFees = minimun.toString();
    }

    else {
      this.otherList.auditFees = '';
    }
  }
  downloadFile(fileName: string) {
    const fileUrl = this.configService.getFileUrl() + 'BalanceSheet/' + fileName;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    link.click();
  }



  async confirmDelete(balanceSheetID: number): Promise<void> {
    const transId = this.iSocietyDetailsTransId ?? 0;

    const confirmed = await this.alertService.confirmAlert(
      'Balance Sheet',
      'Are you sure you want to delete Balance Sheet data?',
      'Submit',
      'No'
    );

    if (!confirmed) {
      return;
    }

    if (balanceSheetID && balanceSheetID !== 0) {
      this.balanceList.iSocietyTransID = transId;

      this.auditService.deleteBalance(balanceSheetID).subscribe({
        next: (response) => {
          this.toastService.showSuccess(response.message);

          if (this.iSocietyDetailsTransId !== null) {
            this.GetAllData(this.iSocietyDetailsTransId);
          }
        },
        error: (error) => {
          this.toastService.showError(
            error.message || 'Error deleting BalanceSheet.'
          );
        },
      });
    } else {
      this.toastService.showError('Invalid BalanceSheet ID.');
    }
  }

  previewAudit(): void {
    this.router.navigate([
      '/audit/auditpreview',
      this.iSocietyDetailsId,
      this.iSocietyDetailsTransId,
    ]);
  }
  filteredStatus: any;
  //Method for get View data from table by Id
  auditStatus(iSocietyDetailsId: number, iAllotAuditorID: number): void {
    this.allotService
      .getAllotAuditorStatus(iSocietyDetailsId, iAllotAuditorID)
      .subscribe(
        (response: any) => {
          this.filteredStatus = response.data;
        },
        (error: { message: string }) => {
          this.toastService.showError(error.message);
        }
      );
  }
}
